<script lang="ts">
	import Fa from 'svelte-fa';
	import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
	import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';

	interface Props {
		paused: boolean;
		large?: boolean;
		classes?: string;
		buttonSizeClasses?: string;
		iconSizeClasses?: string;
		pauseLabel?: string;
		playLabel?: string;
		playIcon?: IconDefinition;
		pauseIcon?: IconDefinition;
		onclick?: (event: MouseEvent) => void;
	}

	let {
		paused,
		large = false,
		classes = '',
		buttonSizeClasses = '',
		iconSizeClasses = '',
		pauseLabel = '',
		playLabel = '',
		playIcon = faPlay,
		pauseIcon = faPause,
		onclick
	}: Props = $props();

	// Backward compatibility: if large is true and no custom classes provided
	const classBig = large ? 'btn-icon-lg' : '';
	const defaultButtonClasses = ['btn-icon', 'bg-primary-500', 'text-white', 'text-center'];

	let finalButtonClasses = $derived(
		buttonSizeClasses
			? [...defaultButtonClasses, buttonSizeClasses]
			: [...defaultButtonClasses, classBig]
	);

	// svelte-fa ^4 IconSize excludes empty string; map "no size" → undefined.
	let iconSize: '1.5x' | undefined = $derived(
		iconSizeClasses ? undefined : large ? '1.5x' : undefined
	);

	function handleKeydown(event: KeyboardEvent) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			// Dispatch click event for consistency
			(event.target as HTMLElement)?.click();
		}
	}
</script>

<button
	class="{finalButtonClasses.join(' ')} {classes}"
	{onclick}
	onkeydown={handleKeydown}
	title={paused ? playLabel : pauseLabel}
	aria-label={paused ? playLabel : pauseLabel}
>
	<Fa icon={paused ? playIcon : pauseIcon} size={iconSize} class={iconSizeClasses} />
</button>
